<template>
    <div>
        <a ref="download"></a>
        <div v-if="showImageModal">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog modal-small-viewer">
                            <div class="modal-content modal-small-viewer">
                                <div class="modal-header">
                                    <button type="button" class="close" @click="showImageModal=false">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <h4 class="modal-title">High-Confidence Phenotypic Matches</h4>
                                </div>
                                <div class="modal-body" style="font-size: 13px;">
                                    To compare knockdown phenotypes, the similarity of the phenotypic profiles for each gene pair were measured using either the Connection Specificity Index (CSI) (<router-link to="/eecdProjectDescription">Sonnichsen et al., 2005</router-link>, <router-link to="/embdProjectDescription">Green et al., 2011</router-link>) or the Phenotypic Angle of Deviation (PAD) (<router-link to="/embdProjectDescription">Green, Khaliullin et al., 2024</router-link>). Conditions with the highest <a @click="showImageModal = false; showModalCSI = true;">CSI</a> or <a @click="showImageModal = false; showModalPAD = true;">PAD</a> scores were rank ordered. High confidence matches are genes that appear on each other’s best match list (<a @click="showImageModal = false; showModalRec = true;">reciprocal match</a>).
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <div v-if="showModalCSI">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog modal-small-viewer">
                            <div class="modal-content modal-small-viewer">
                                <div class="modal-header">
                                    <button type="button" class="close" @click="showModalCSI=false">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <h4 class="modal-title">Connection Specificity Index (CSI)</h4>
                                </div>
                                <div class="modal-body" style="font-size: 13px;">
                                    The Connection Specificity Index (CSI) is a graph-theory based metric that evaluates the similarity and specificity of each pair of phenotypes by measuring the number of other genes in the dataset that have knockdown phenotypes that are as or more similar to the phenotypes of either query gene (as assessed by the Pearson’s Correlation Coefficient) than the phenotypes of the queried genes are to each other. Thus, a CSI of 0.99 means that the phenotypes of the two query genes are more similar to each other than they are to the phenotypes for 99% of the genes in the dataset (<router-link to="/embdProjectDescription">Green et al., 2011</router-link>).
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <div v-if="showModalPAD">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog modal-small-viewer">
                            <div class="modal-content modal-small-viewer">
                                <div class="modal-header">
                                    <button type="button" class="close" @click="showModalPAD=false">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <h4 class="modal-title">Phenotypic Angle of Deviation (PAD)</h4>
                                </div>
                                <div class="modal-body" style="font-size: 13px;">
                                    The Phenotypic Angle of Deviation (PAD) compensates for the increase in stochastic variation that is observed as phenotypes become more severe. This metric combines the power of similarity metrics, which captures the angle of spread, and distance metrics, which precisely measure the distance between two compared conditions in multidimensional space. To generate this metric, we normalize the distance between two phenotypes by dividing the Euclidean distance between the considered gene-pair by the sum of the distance to WT for the two vectors. We normalize this on a 0 to 1 scale for simplicity- where values approaching 1 are phenotypically the most similar and values approaching 0 are dissimilar. This transforms the Euclidean Distance measures into PAD values.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <div v-if="showModalRec">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog modal-small-viewer">
                            <div class="modal-content modal-small-viewer">
                                <div class="modal-header">
                                    <button type="button" class="close" @click="showModalRec=false">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <h4 class="modal-title">Reciprocal match</h4>
                                </div>
                                <div class="modal-body" style="font-size: 13px;">
                                    Reciprocal phenotypic matches represent high-confidence phenotypic matches where the query gene and the 'hit' are in each others top 10 phenotypic matches, based on rank-ordered <a @click="showModalRec = false; showModalCSI = true;">CSI</a> (Germline or Early Embryo Screen) or <a @click="showModalRec = false; showModalPAD = true;">PAD</a> (Embryonic Development Screen) values.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <table :id=id class="table table-striped table-bordered table-hover" width="100%"></table>
    </div>
</template>

<script>
  const _ = require('lodash');
  const $ = window.jQuery = require('jquery');
  require('./js/datatable');

  let table;

  export default {
    name: 'data-table',
    props: ['id', 'data', 'keyword'],
    data() {
      return {
        selectedItem: 'Genes',
        showImageModal: false,
        showModalCSI: false,
        showModalPAD: false,
        showModalRec: false,
      };
    },
    // watch: {
    //   selectedItem: function update(newValue) {
    //     const vm = this;
    //
    //     switch (newValue) {
    //       case 'Genes':
    //       default:
    //         vm.createTable(vm.id, vm.data);
    //     }
    //   },
    // },
    methods: {
      fetchGeneFromEmbd(locusName) {
        // const url = `http://localhost:3000/api/embd/${geneId}`;
        // const url = `/fetchItem/${geneId}`
        // eslint-disable-next-line
        // this.router.push({name: 'fetch_item', params: { itemId: geneId }})
        console.log(locusName);
        const url = `/itemView/${locusName}`
        // // eslint-disable-next-line
        // console.log(url)
        // window.open(url)
        this.$router.push({ path: url })
      },
      test() {

      },
      createTable(id, data) {
        const vm = this;

        _.forEach(data, (d) => {
          d.DT_RowID = `${d.locusName}`;
        });

        const columns = [
          {
            title: 'Gene',
            data: 'locusName',
            fnCreatedCell: (nTd, sData, oData) => {
              $(nTd).html(`<a href="" class="url-link gene">${oData.locusName}</a>`.replace(new RegExp(vm.keyword, 'gi'), `<mark>$&</mark>`));
            },
          },
          {
            title: `<table class="pheno"><tr><td class="pheno-title" colspan="3"><b style="color: #251e8c;">High-Confidence Phenotypic Matches</b> <a href="#" id="showModal">(explain)</a></td></tr><tr><td class="pheno" style="border-left-width: 0;">Germline</td><td class="pheno">Early Embryo</td><td class="pheno">Embryonic Development</td></tr></table>`,
            data: 'locusName',
            width: '330px',
            orderable: false,
            fnCreatedCell: (nTd, sData, oData) => {
              // $(nTd).html(sData.split(vm.keyword).join(`<mark>${vm.keyword}</mark>`));
              var html = []

              html.push('<table style="width: 100%"><tr><td class="pheno-item"><ul>')

              if(oData.gm_tophits) {
                _.each(_.take(oData.gm_tophits, 5), (i) => {
                  html.push(`<li><a class="tophit-link" href=/eecdView/${i}>${i.replace(new RegExp(vm.keyword, 'gi'), `<mark>$&</mark>`)}</a>`);
                });
              } else {
                html.push(`<li>N/A</li>`)
              }

              html.push('</ul></td>')

              html.push('<td class="pheno-item"><ul>')
              if(oData.ee_tophits) {
                _.each(_.take(oData.ee_tophits, 5), (i) => {
                  html.push(`<li><a class="tophit-link" href=/eecdView/${i}>${i.replace(new RegExp(vm.keyword, 'gi'), `<mark>$&</mark>`)}</a>`);
                });
              } else {
                html.push(`<li>N/A</li>`)
              }
              html.push('</ul></td>')

              html.push('<td class="pheno-item"><ul>');
              if(oData.em_tophits) {
                _.each(_.take(oData.em_tophits, 5), (i) => {
                  if(i === 'Embryos do not exhibit an arrest phenotype') {
                    html.push(`<li style="color: red">${i}`);
                  } else {
                    html.push(`<li><a class="tophit-link" href="/embdView/${i.trim()}">${i.replace(new RegExp(vm.keyword, 'gi'), `<mark>$&</mark>`)}</a>`);
                  }
                });
              } else {
                html.push(`<li>N/A</li>`)
              }
              html.push('</ul></td></tr></table>')

              $(nTd).html(html.join('\n'));
              // $(nTd).html(oData.tophits);
            }
          },
          {
            title: 'Phenotypic Class/Category',
            data: 'locusName',
            fnCreatedCell: (nTd, sData, oData) => {
              // $(nTd).html(sData.split(vm.keyword).join(`<mark>${vm.keyword}</mark>`));
              let html = []
              if(oData.gm || oData.ee) {
                if (oData.gm) {
                  html.push(`<span style="font-weight: bold">Germline:</span>`)
                  _.each(oData.gm_data, i => {
                    html.push(`${i.class.replace(new RegExp(vm.keyword, 'gi'), `<mark>$&</mark>`)}`);
                    // html.push(`<p>${i.broadCategory.replace(new RegExp(vm.keyword, 'gi'), `<mark>$&</mark>`)}</p>`);
                  })
                  html.push('<br/><br/>')
                }
                if (oData.ee) {
                  let classes = []
                  _.each(oData.ee_data, i => {
                    if(i.testType === 8) classes.push(i.className)
                  })

                  classes = _.uniq(classes)

                  if(classes.length > 0) {
                    html.push(`<span style="font-weight: bold">Early Embryo:</span>`)
                    html.push(`${classes.join(',').replace(new RegExp(vm.keyword, 'gi'), `<mark>$&</mark>`)}`);
                  }
                }
                $(nTd).html(html.join('\n'));
              }

              else {
                $(nTd).html('');
              }
            }
          },
          {
            title: 'Description',
            data: 'description',
            fnCreatedCell: (nTd, sData, oData) => {
              // $(nTd).html(sData.split(vm.keyword).join(`<mark>${vm.keyword}</mark>`));
              if(sData !== null) {
                let desc = ''
                if(sData.length > 300) {
                  desc = sData.substr(0, 300) + '...'
                } else {
                  desc = sData.substr(0, 300)
                }
                $(nTd).html(desc.replace(new RegExp(vm.keyword, 'gi'), `<mark class="no-padding">$&</mark>`));
              }
            }
          },
          {
            title: 'GO Terms',
            data: 'gos',
            fnCreatedCell: (nTd, sData, oData) => {
              if(oData.gos !== null) {
                let goterms = [];
                let overflow = '';
                _.each(oData.gos, (i) => {
                  if(goterms.join(', ').length > 300) {
                    overflow = '...';
                    return;
                  }

                  goterms.push(`${i[1]}(${i[0]})`)
                })

                $(nTd).html(goterms.join(', ').replace(new RegExp(vm.keyword, 'gi'), `<mark class="no-padding">$&</mark>`) + overflow);
                // $(nTd).html(oData.gos);
              }
            },
          }
        ];

        const nTableOptions = {
          columns,
          // aaSorting: [[ 0, 'asc' ]],
          paging: true,
          searching: true,
          info: true,
          data,
          order: [], // order: [[0, 'asc']],
          bDestroy: true, // Add this property to new setting,
          oLanguage: {
            sSearch: "Filter",
          },
          dom: '<"row"<"col-sm-4"l><"col-sm-6"f><"#download.col-sm-2">><"row"t><"row"<"col-sm-4"i><"col-sm-8"p>>'
        };

        const tableId = `#${id}`;
        if (table) {
          table.destroy();
          $(tableId).empty();
        }

        table = $(tableId).DataTable(nTableOptions);

        $("#download").html('<div style="text-align: right;"><div class="dropdown">\n' +
          '  <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">\n' +
          '    Download\n' +
          '  </button>\n' +
          '  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">\n' +
          '    <a class="dropdown-item" href="#" ref="csv">CSV</a>\n' +
          '    <a class="dropdown-item" href="#" ref="tsv">TSV</a>\n' +
          '    <a class="dropdown-item" href="#" ref="json">JSON</a>\n' +
          '  </div>\n' +
          '</div></div>');

        const tableBody = `${tableId} tbody`;

        $(tableBody).on('click', 'tr td a.url-link', (e) => {
          e.preventDefault()
          const tr = $(e.target).parent().parent();
          const row = table.row(tr);
          vm.fetchGeneFromEmbd(row.data().locusName);
        });

        $('#download').on('click', 'a.dropdown-item', (e) => {
          e.preventDefault()
          switch ($(e.target).text()) {
            case 'CSV':
              vm.downloadCsv(); break;
            case 'TSV':
              vm.downloadTsv(); break;
            case 'JSON':
              vm.downloadJson(); break;
          }
        });

        $('#showModal').on('click', (evt) => {
          vm.showImageModal = true
        });
      },
      downloadCsv() {
        const vm = this;
        let exports = [];

        let header = ['Gene', 'Phenotypic Top Matches', 'Phenotypic class/category', 'Description', 'GO Terms'];
        exports.push(header.join(', '));

        _.forEach(vm.data, item => {
          let goTerms = [];
          _.each(item.gos, (i) => {
            goTerms.push(`${i[1]}(${i[0]})`)
          })

          let tophits = [];
          _.each(item.em_tophits, (i) => {
            tophits.push(`${i}`)
          })
          _.each(item.ee_tophits, (i) => {
            tophits.push(`${i}`)
          })
          _.each(item.gm_tophits, (i) => {
            tophits.push(`${i}`)
          })

          let phenoClass = []
          if(item.gm || item.ee) {
            if (item.gm) {
              phenoClass.push('Germline: ')
              _.each(item.gm_data, i => {
                phenoClass.push(i.class.replace(/,/g, '-'))
              })
            }
            if (item.ee) {
              let classes = []
              _.each(item.ee_data, i => {
                if(i.testType === 8) classes.push(i.className)
              })

              classes = _.uniq(classes)

              if(classes.length > 0) {
                phenoClass.push('Early Embryo: ')
                phenoClass.push(`${classes.join('-')}`)
              }
            }
          }

          exports.push([item.locusName, tophits.join('\t'), phenoClass.join('\t'), `"${item.description}"`, `"${goTerms.join('\t')}"`].join(','));
        })

        let blob = new Blob([exports.join('\n')], {type: 'text/csv'})

        let contentDisposition = 'Content-Disposition: attachment; filename="download-data.csv"'
        let filename = contentDisposition.split('filename=')[1]
        filename = filename.replace(/"/g, '')

        let link = vm.$refs.download
        link.href = window.URL.createObjectURL(blob)
        link.download = filename
        link.click()
      },
      downloadTsv() {
        const vm = this;
        let exports = [];

        let header = ['Gene', 'Phenotypic Top Matches', 'Phenotypic class/category', 'Description', 'GO Terms'];
        exports.push(header.join('\t'));

        _.forEach(vm.data, item => {
          let goTerms = [];
          _.each(item.gos, (i) => {
            goTerms.push(`${i[1]}(${i[0]})`)
          })

          let tophits = [];
          _.each(item.em_tophits, (i) => {
            tophits.push(`${i}`)
          })
          _.each(item.ee_tophits, (i) => {
            tophits.push(`${i}`)
          })
          _.each(item.gm_tophits, (i) => {
            tophits.push(`${i}`)
          })

          let phenoClass = []
          if(item.gm || item.ee) {
            if (item.gm) {
              phenoClass.push('Germline: ')
              _.each(item.gm_data, i => {
                phenoClass.push(i.class)
              })
            }
            if (item.ee) {
              let classes = []
              _.each(item.ee_data, i => {
                if(i.testType === 8) classes.push(i.className)
              })

              classes = _.uniq(classes)

              if(classes.length > 0) {
                phenoClass.push('Early Embryo: ')
                phenoClass.push(`${classes.join(', ')}`)
              }
            }
          }

          exports.push([item.locusName, tophits.join(', '), phenoClass.join(' '), item.description, goTerms.join(', ')].join('\t'));
        })

        let blob = new Blob([exports.join('\n')], {type: 'text/tsv'})

        let contentDisposition = 'Content-Disposition: attachment; filename="download-data.tsv"'
        let filename = contentDisposition.split('filename=')[1]
        filename = filename.replace(/"/g, '')

        let link = vm.$refs.download
        link.href = window.URL.createObjectURL(blob)
        link.download = filename
        link.click()
      },
      downloadJson() {
        const vm = this;
        let blob = new Blob([JSON.stringify(vm.data, null, 2)], {type: 'application/json'})

        let contentDisposition = 'Content-Disposition: attachment; filename="download-data.json"'
        let filename = contentDisposition.split('filename=')[1]
        filename = filename.replace(/"/g, '')

        let link = vm.$refs.download
        link.href = window.URL.createObjectURL(blob)
        link.download = filename
        link.click()
      },
    },
    mounted() {
      const vm = this;
      vm.createTable(vm.id, vm.data);
    },
  };
</script>

<style>
    @import url('~@/assets/datatable.css');

    .modal-title {
        color: #114188;
        font-weight: bold;
        font-size: 18px;
    }

    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-small-viewer {
        width: 600px;
    }

</style>
